import { createStore } from 'vuex'
import auth from './modules/auth'
import company from './modules/company'

export default createStore({
  modules: { auth, company }
})
